<template>
  <div class="self-service-pre-offers">
    <Alert
      class="m-1 mb-2"
      :message="t('CUSTOMER_APPROVED')"
      alertType="alert-success"
      alertIcon="fa fa-star"
      :isSelfService="true"
    />
    <ConfettiExplosion :force="1" />

    <div class="row text-center">
      <div class="col-12 mt-3 mb-3">
        <h1>{{ t("SS_SURVEY_TITLE") }}</h1>
        <p class="fs-3">{{ t("SS_PRE_SURVEY_DESCRIPTION") }}</p>
      </div>
    </div>

    <div class="row text-center">
      <div class="d-grid d-sm-block">
        <button
          data-testid="btn-show-survey"
          class="btn btn-success fs-3 me-3 pj-ss-btn pj-wide"
          @click="$emit('showSurvey', true)"
        >
          {{ t("SS_PRE_SURVEY_OPTION_1") }}
        </button>
        <button
          data-testid="btn-skip-survey"
          class="btn btn-success fs-3 mt-4 pj-ss-btn pj-wide"
          @click="$emit('showSurvey', false)"
        >
          {{ t("SS_PRE_SURVEY_OPTION_2") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Alert from "@/apps/merchant3/shared-components/common/Alert.vue";
import ConfettiExplosion from "vue-confetti-explosion";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

const { t } = useI18n();
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
h1 {
  color: $pj-color-green;
}

p {
  font-size: 1.5em;
}

.link-green {
  color: $pj-color-green;
  font-size: 1rem;

  a {
    text-decoration: none;
    color: $pj-color-green;
  }
}
</style>
